module.exports = __webpack_public_path__ + "img/msg_pic.2212e01a.svg";